import { ChevronDown, ChevronUp, X } from "lucide-react";
import { useState } from "react";

export type CollapsableFormProps = {
  children: React.ReactNode;
  title: string;
  onRemove: () => void;
  id: string;
};

export function CollapsableForm({ children, title, onRemove, id }: CollapsableFormProps) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        data-testid={`${id}-toggle`}
        className="flex items-center gap-1 rounded-t-md bg-gray-100 p-1 text-xs font-semibold"
      >
        {title}
        {isOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronUp className="h-4 w-4" />}
      </button>
      {isOpen && (
        <div className="relative rounded-r-md rounded-bl-md bg-gray-100 p-4">
          <button
            onClick={onRemove}
            data-testid={`${id}-remove`}
            className="absolute -right-1 -top-1 rounded bg-white p-1 outline hover:bg-gray-200"
          >
            <X className="h-4 w-4 text-gray-800" />
          </button>
          {children}
        </div>
      )}
    </div>
  );
}
